import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const prApi = createApi({
  reducerPath: 'personal_records',
  tagTypes: ['PersonalRecord'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchRecords: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'PersonalRecord', id: 'LIST' },
                ...result.map((r) => ({ type: 'PersonalRecord', id: r.id })),
              ]
            : [{ type: 'PersonalRecord', id: 'LIST' }],
        query: () => ({
          url: '?resource=personal_record&order=created_at.asc',
          method: 'GET',
        }),
      }),

      createRecord: builder.mutation({
        invalidatesTags: [{ type: 'PersonalRecord', id: 'LIST' }],
        query: (data) => ({
          url: '?resource=personal_record',
          method: 'POST',
          body: data,
        }),
      }),

      updateRecord: builder.mutation({
        invalidatesTags: (result, error, { id: personal_recordId }) => [
          { type: 'PersonalRecord', id: personal_recordId },
          { type: 'PersonalRecord', id: 'LIST' },
        ],
        query: ({ id: personal_recordId, submitData }) => ({
          url: `?resource=personal_record&id=eq.${personal_recordId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchRecord: builder.query({
        providesTags: (result, error, arg) => [{ type: 'PersonalRecord', id: arg }],
        query: (personal_recordId) => ({
          url: `?resource=personal_record&id=eq.${personal_recordId}`,
          method: 'GET',
        }),
      }),

      fetchRecordByAthleteId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'PersonalRecord', id: 'LIST' },
                ...result.map((r) => ({ type: 'PersonalRecord', id: r.id })),
              ]
            : [{ type: 'PersonalRecord', id: 'LIST' }],
        query: (athleteId) => ({
          url: `?resource=personal_record&athlete=eq.${athleteId}&order=created_at.desc`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchRecordsQuery,
  useCreateRecordMutation,
  useUpdateRecordMutation,
  useFetchRecordQuery,
  useFetchRecordByAthleteIdQuery,
} = prApi;

export { prApi };
